// Modal Content, This content is mainly used for Modal wrap with MainModal.tsx Component
import SearchBar from "./SearchBar";
import ContainerCheckBox from "./ContainerCheckBox";
import uk from "../assets/icons/uk.svg";
import india from "../assets/icons/india.svg";
import moldova from "../assets/icons/moldova.svg";
import germany from "../assets/icons/germany.svg";
import france from "../assets/icons/france.svg";
import PrimaryButton from "./PrimaryButton";

const lngData = [
  { icon: <img src={uk} alt="flag" />, title: "English" },
  { icon: <img src={germany} alt="flag" />, title: "German" },
  { icon: <img src={india} alt="flag" />, title: "Hindi" },
  { icon: <img src={france} alt="flag" />, title: "French" },
  { icon: <img src={moldova} alt="flag" />, title: "Moldovian" },
  { icon: <img src={uk} alt="flag" />, title: "Belgium" },
  { icon: <img src={france} alt="flag" />, title: "Georgian" },
];

const TranslateToModal = ({showNext, subTitle}: {showNext? : () => void, subTitle?: string}) => {
  return (
    <>
      {
        subTitle &&
        <p className="text-zinc-400 text-sm font-medium tracking-tight mt-1">{subTitle}</p>
      }
      <SearchBar className="bg-white w-full rounded-full text-xs mt-3" inputCss="bg-white" placeholder="Search language" />
      <div className="flex flex-col gap-2 my-3">
        {lngData.map((item, idx) => (
          <ContainerCheckBox
            icon={item.icon}
            key={idx}
            title={item.title}
            type="radio"
            voice="Rahul’s voice"
          />
          ))}
      </div>
      <PrimaryButton onClick={() => showNext && showNext()} className="py-2 rounded-3xl" label="Proceed" />
    </>
  );
};

export default TranslateToModal;